<template>
  <div>
   <b-row no-gutters style="display: flex;align-items: center;justify-content: center;">
     <b-col md="11" style="margin-top:30px;">
       <b-card
       no-body
         class="overflow-auto card"
         style="padding:0;"
       >
       <div class="panel">
         <div class="container py-3">
           <div class="row align-items-center">
             <!-- Title -->
             <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
               <strong class="text-white font-weight-black font-monospace" style="font-size: 1.3em;">
                 All Transactions
               </strong>
             </div>
             <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
             <select class="form-control" name="" id="" @change="FilterExpense">

              <option value="">All</option>
              <option value="0">Pending</option>
              <option value="2">Accepted</option>
              <option value="3">Delivered</option>
              <option value="1">Rejected</option>
            </select>
            </div>
             <!-- Add Expense Button -->
             <div class="col-12 col-md-12 text-center text-md-start mb-12 mb-md-0" style="color:white;margin-top:20px;display:flex;justify-content:center;">
              <b-row no-gutters  >
                <b-col md='auto' >
                  <div style="float:left;">
           <label  for="" style="color:white;padding-top:4px;margin-right:5px;">From :</label> <input type="date" name="" id="" placeholder="from" v-model="from" style="border:0.5px solid grey;border-radius: 5px;">
           </div>
                </b-col>
                <b-col md='auto'>
                  <div style="float:left;">
           <label for="" style="color:white;padding-top:4px;margin-right:30px;margin-left:20px;">to :</label><input type="date" name="" id="" placeholder="to" v-model="to" style="border:0.5px solid grey;border-radius: 5px;">
                  </div>
                </b-col>
                <b-col md="auto">
                  <div >
           <b-button class="btn btn-success btn-sm" @click="FilterExpenseDate" style="margin-left:10px; 
           background: linear-gradient(to right, #0f2027, #203a43, #2c5364);"> Filter</b-button>

            <b-button class="btn btn-success btn-sm" @click="ClearData()" style="margin-left:10px; 
           background: linear-gradient(to right, #0f2027, #203a43, #2c5364);"> Clear</b-button>
                  </div>
                </b-col>
              </b-row>
              </div>
           </div>
         </div>
         
         <div class="panel-body table-responsive">
           <datatable
             :columns="columns"
             :data="expenses.data"
             class="table table-striped text-nowrap"
             style="text-align: center; color: white;"
           >
             <template slot-scope="{ row, index }">
               <tr>
                 <td class="align-middle">{{ index + 1 }}</td>
                 <td class="align-middle">{{ row.from.country }} / <img :src="'http://flagcdn.com/w320/'+row.from.code+'.png'" alt="" style="height: 20px;;"></td>
                 <td class="align-middle">{{ row.to.country }} / <img :src="'http://flagcdn.com/w320/'+row.to.code+'.png'" alt="" style="height: 20px;;"></td>
                 <td class="align-middle">{{row.amount +' '+currency[row.from.code]}}</td>
                 <td class="align-middle">{{row.rate +' '+currency[row.to.code]}}</td>
                 <td class="align-middle">{{row.recivable +' '+currency[row.to.code]}}</td>
                 <td class="align-middle">{{row.total +' '+currency[row.from.code]}}</td>
                 <td style="vertical-align: middle"><span class="badge badge-pill btn-primary"   v-if='row.state==0'>Pending</span><span class="badge badge-pill badge-danger" v-if='row.state==1'>Rejected</span><span class="badge badge-pill badge-success" v-if='row.state==2'>Accepted</span> <span class="badge badge-pill badge-primary" v-if='row.state==3'>Delivered</span></td>
                 <td class="align-middle">{{ row.created_at | myDate }}</td>
                 <td class="align-middle">
                   <b-dropdown variant="link" no-caret right>
                     <template v-slot:button-content>
                       <i class="fas fa-ellipsis-v text-secondary"></i>
                     </template>
                     <b-dropdown-item @click="Editexpense(row, index)"  v-b-modal="'post-update-modal-expense-view'">
                       <i class="fa fa-eye text-secondary mr-2"></i> View
                     </b-dropdown-item>
                   </b-dropdown>
                 </td>
               </tr>
             </template>
             
           </datatable>
           <template v-if="!expenses.data.length">
            <div class="text-center text-white py-3 w-100">
              <i class="fas fa-database fa-2x text-secondary"></i>
              <p class="mt-2"><strong>No Data Found</strong></p>
              <p>🔍 Try searching again or adding new data.</p>
            </div>
          </template>
         </div>
         
       </div>
         <div style="float:right;">
           <pagination :data="expenses" @pagination-change-page="getmyexpense">
              </pagination>
        </div>
       </b-card>
     </b-col>
   </b-row>
   
    <b-modal :id="'post-update-modal-expense'" :size="'md'">
         <div style="padding-left:20px;padding-top:15px;padding-bottom:5px;border-bottom:1px solid rgba(214,214,214);font-size:1.3em;">{{display?'Update Transaction':'Add Transaction'}} <span><i class="fas fa-times" style="float:right;margin-right:20px;margin-top:5px;color:grey;" @click="closemoadl('post-update-modal-expense')"></i></span></div>
     <form
        style="padding:30px;padding-top:15px;margin-bottom:35px;"
       @submit.prevent="display ? update() : create()"
     >
     
       <div class="form-group row">
         <label>From</label>
         <select
         required
           v-model="expense.sender"
           @change="FilterCountry()"
           name="sender"
           placeholder="sender"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('sender') }"
         >
        <option value="">Select From</option>
        <option :value="contry.id" v-for="contry in countrys" :key="contry.id"><img :src="'http://flagcdn.com/w320/'+contry.code+'.png'" alt="" style="height: 100px;;">{{contry.country}}</option>
        </select>
         <has-error :form="expense" field="sender"></has-error>
       </div>
       <div class="form-group row">
        <label>To</label>
        <select
         required
         @change="UpdateReciver"
           name="reciver"
           placeholder="reciver"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('reciver') }"
         >
        <option value="">Select To</option>
        <option :value="JSON.stringify(contry)" v-for="contry in recivers_h" :key="contry.id"><img :src="'http://flagcdn.com/w320/'+contry.to.code+'.png'" alt="" style="height: 20px;;">{{contry.to.country}}</option>
        </select>
        <has-error :form="expense" field="reciver"></has-error>
      </div>
      <div class="form-group row">
        <label>Full Name</label>
        <input
         required
           v-model="expense.full_name"
           name="full_name"
           placeholder="full name"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('full_name') }"
         >
        <has-error :form="expense" field="full_name"></has-error>
      </div>

      <div class="form-group row">
        <label>Phone Number</label>
        <input
         required
           v-model="expense.phone_number"
           name="phone_number"
           placeholder="phone Number"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('phone_number') }"
         >
        <has-error :form="expense" field="phone_number"></has-error>
      </div>

      <div class="form-group row">
        <label>Bank Account (optional)</label>
        <input
         
           v-model="expense.bank"
           name="bank"
           placeholder="bank Account"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('bank') }"
         >
        <has-error :form="expense" field="bank"></has-error>
      </div>
      
      <div class="form-group row">
        <span v-if="selectedFile" class="file-name">{{ selectedFile }}</span>
       </div>
       <div class="form-group row">
        
            <input
       style="box-shadow:none;padding-bottom:40px;font-size:100%;"
       class="form-control login-input"
        :class="{ 'is-invalid': expense.errors.has('attachment') }"
          @change="attachmentprocessor"
         required
         name="attachement"
         type="file"
         tabindex="1"
         autocomplete="off"
       />       
     
        <has-error :form="expense" field="attachement" style="color:red;"></has-error>
      
      </div>

       <div class="form-group row">
         <label>Sending Amount</label>
         <input
         required
           v-model="expense.amount"
           @keyup="UpdateRecivable()"
           name="amount"
           placeholder="amount"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('amount') }"
         />
         <has-error :form="expense" field="amount"></has-error>
       </div>

       <div class="form-group row">
        <label>Reciving Amount</label>
        <input
        disabled
          v-model="expense.recivable"
          name="amount"
          placeholder="0"
          class="form-control"
          :class="{ 'is-invalid': expense.errors.has('amount') }"
        />
        <has-error :form="expense" field="amount"></has-error>
      </div>
      
      
        <div style="display: flex;justify-content:space-between;font-size:1.3em;" class="form-group row"> <span >Exchange Rate</span>  <strong v-if="this.from_cur">{{this.from_cur}} 1 = {{ this.to_cur+' '+this.exchange_rate }} </strong> </div>
        
      

      <div style="display: flex;justify-content:space-between;font-size:1.3em;" class="form-group row">
        <span>Total Pay</span>  <strong >{{Number(this.total_payable).toFixed(2)}}</strong>
        
      </div>
       <div  style='border-top:1px solid rgba(0.5,0.5,0.5,0.3);padding-top:10px;margin-top:15px;'>
       <div class="float-right" v-if="user.state==2">
         <b-button type="submit"  class="btn-primary" v-if="!display">
           Save
         </b-button>
         <b-button type="submit" class="btn-primary" v-if="display">
           Update
         </b-button>
       </div>
       </div>
     </form>
   </b-modal>



   <b-modal :id="'post-update-modal-expense-view'" :size="'lg'" v-if="holder.id">
    <div style="padding-left: 20px; padding-top: 15px; padding-bottom: 5px; border-bottom: 1px solid rgba(214, 214, 214); font-size: 1.3em;">
      Detail 
      <span>
        <i class="fas fa-times" 
           style="float: right; margin-right: 20px; margin-top: 5px; color: grey;" 
           @click="closeModal('post-update-modal-expense-view')">
        </i>
      </span>
    </div>
    
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; padding: 20px;">
      <div>
        <h5>From: {{ holder.from.country }} / 
          <img :src="'http://flagcdn.com/w320/' + holder.from.code + '.png'" alt="Sender Flag" style="height: 20px;">
        </h5>
        
        <h5>To: {{ holder.to.country }} / 
          <img :src="'http://flagcdn.com/w320/' + holder.to.code + '.png'" alt="Receiver Flag" style="height: 20px;">
        </h5>
        
        <h5>Sending Amount: {{ holder.amount + ' ' + currency[holder.from.code] }}</h5>
        <h5>Rate: {{ holder.rate + ' ' + currency[holder.to.code] }}</h5>
      </div>
  
      <div>
        <h5>Receivable: {{ holder.recivable + ' ' + currency[holder.to.code] }}</h5>
        <h5>Total Paid: {{ holder.total + ' ' + currency[holder.from.code] }}</h5>
        
      
      </div>
    </div>
    <div>
      <form
      style="padding:30px;padding-top:15px;margin-bottom:35px;"
     @submit.prevent="CreateData()"
   >
     <div class="form-group row" v-if="holder.state==0">
       <label>Delivery Hours</label>
       <input
       required
         v-model="hours"
         name="hours"
         placeholder="hours"
         class="form-control"
       />
     </div>
     <div class="form-group row" v-if="holder.state==2">
      <span v-if="selectedFile" class="file-name">{{ selectedFile }}</span>
     </div>
     <div class="form-group row" v-if="holder.state==2">
        
      <input
 style="box-shadow:none;padding-bottom:40px;font-size:100%;"
 class="form-control login-input"
    @change="attachmentprocessor"
   required
   name="attachement"
   type="file"
   tabindex="1"
   autocomplete="off"
 />       

  <has-error :form="expense" field="attachement" style="color:red;"></has-error>

</div>
    
     <div  style='border-top:1px solid rgba(0.5,0.5,0.5,0.3);padding-top:10px;margin-top:15px;'>
     <div class="float-right">
       <b-button type="submit"  class="btn-primary" v-if="holder.state==0">
         Accept
       </b-button>
       <b-button type="submit" class="btn-primary" v-if="holder.state==2">
         Done
       </b-button>
     </div>
     </div>
   </form>
    </div>
    <div class="image-container">
      <img 
        :src="'https://my.flylikeeagle.com/backend/public/storage/uploads/images/' + holder.image" 
        class="user-image" 
        alt="Transaction Image" 
        style="max-width: 100%; height: auto;">
    </div>
    <div class="image-container" v-if="holder.state==3">
      <img 
        :src="'https://my.flylikeeagle.com/backend/public/storage/uploads/images/' + holder.image_d" 
        class="user-image" 
        alt="Transaction Image" 
        style="max-width: 100%; height: auto;">
    </div>
  </b-modal>
  
  
 </div>
</template>
<script>
export default {
 data() {
   return {
    hours:0,
    from:'',
    to:'',
    currency:{'et':'ETB','us':'USD','au':'AUD'},
    selectedFile: "Upload Transaction Recipt",
    recivers:[],
    countrys:[],
    recivers_h:[],
     form:new window.Form({
     search:''
           }),
     updateindex:-1,
     columns: [
       { label: "No" },
       { label: "From" },
       { label: "To" },
       { label: "Amount" },
       { label: "Rate" },
       { label: "Recivable" },
       { label: "Total" },
       { label: "State" },
        { label: "Created At", field: "created_at" },
       { label: "Manage" },
     ],
     active_id:0,
     holder:{},
     exchange_rate:0,
     total_payable:0,
     from_cur:'',
     to_cur:'',
     expenses: {data:[]},
     rates:[],
     user:{},
     tfs:[],
     attachment:'',
     display: false,
     url: "",
     title:'',
     fee:'',
     code:'',
     selected_titles:[],
     isedit:-1,
     expense: new window.Form({
       sender: "",
       recivable:0,
       reciver:'',
       attachment:'',
       amount:0,
       phone_number:'',
       bank:'',
       full_name:'',
       id: "",
     }),
   };
 },
 beforeMount() {
  this.getUserProfile()
  this.getmyexpenserate()
  this.getmyexpensefee()
   this.getmyexpense()
   this.getcountry()
 },
 methods: {
  updateTotalPay(){
    var holder=0
    this.total_payable=0
    var container_d=0
    this.tfs.forEach(element => {
        if(this.expense.amount>=element.init && this.expense.amount<=element.last){
          holder=this.expense.amount-element.init;
          
          this.total_payable=element.per_init*1+this.expense.amount*1
          if(holder>=100 && holder<1000){
           
            this.total_payable+= element.per_inc*Math.floor(holder / 100)
            holder=holder-Math.floor(holder / 100)*100
            
            if(holder>0)
            this.total_payable+=element.per_inc*(holder/100);
          
          }else if(holder>1000){
            console.log(this.total_payable)
            this.total_payable+= element.per_inc*Math.floor(holder / 100)
            console.log(Math.floor(holder / 100))
            console.log(this.total_payable)
             container_d=holder-Math.floor(holder / 100)*100
            
            this.total_payable+= element.per_inc*Math.floor(container_d / 100)
            container_d=container_d-Math.floor(container_d / 100)*100
            if(holder>0)
            this.total_payable+=element.per_inc*(container_d/100);

          }else{
            console.log(this.total_payable)
            console.log(element.per_inc*(holder/100))
            this.total_payable+=element.per_inc*(holder/100);
          }
        }
    });
  },
  UpdateRecivable(){
    this.expense.recivable=this.exchange_rate*this.expense.amount
    this.updateTotalPay()
  },
  getmyexpensefee(page=1) {
     this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_inc','variable':'expense','params':'?page='+page}, { root: true }).then(() => {
       this.tfs=this.$store.getters['admin/Getexpense'].data
     })
   },
  UpdateReciver(e){
    var holder=JSON.parse(e.target.value)
    this.exchange_rate=holder.rate
    this.expense.reciver=holder.to.id
    this.from_cur=this.currency[holder.from.code]
    this.to_cur=this.currency[holder.to.code]
    this.UpdateRecivable()
  },
  getmyexpenserate(page=1) {
     this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_rate','variable':'expense','params':'?page='+page}, { root: true }).then(() => {
       this.rates=this.$store.getters['admin/Getexpense'].data
     })
   },
  FilterCountry(){
    this.recivers_h=[]
    this.rates.forEach(element => {
      if(this.expense.sender==element.sender){
        this.recivers_h.push(element)
      }
    });
  },
  attachmentprocessor (e) {
      var photos = e.target.files[0]
      var file = photos
      var limit = 1024 * 1024 * 2
      if (file.size <= limit) {
        this.attachment = file
        this.selectedFile = file ? file.name : "Upload Your ID";
        this.url = URL.createObjectURL(file)
      }
    },
  getcountry(){
    this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_expense','variable':'expense'}, { root: true }).then(() => {
        var country=this.$store.getters['admin/Getexpense']
        country.data.forEach(element => {
          if(element.sender==1){
            this.countrys.push(element)
          }else{
            this.recivers.push(element)
          }
        });
      })
  },
  FilterExpenseDate(){
      this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to},'method':'post','api':'admin_filter_transaction_admin','variable':'expense','params':this.active_id}, { root: true }).then(() => {
       this.expenses=this.$store.getters['admin/Getexpense']
     })
  },
   FilterExpense(e){
    var id =e.target.value
    if(id){
      this.active_id=id
      this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to},'method':'post','api':'admin_filter_transaction_admin','variable':'expense','params':id}, { root: true }).then(() => {
       this.expenses=this.$store.getters['admin/Getexpense']
     })
    }else{
      this.active_id=0
      this.getmyexpense()
    }
   },
   closemoadl(val){
     this.$bvModal.hide(val)
   },
   resetform() {
     this.expense.reset();
     this.url = "";
     this.display=false
     this.updateindex=-1
   },
   getimage(image){
     return window.image_url+image
   },
   Editexpense(expense) {
     this.holder=expense;
   },
   getmyexpense(page=1) {
     this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_transaction_admin','variable':'expense','params':'?page='+page}, { root: true }).then(() => {
       this.expenses=this.$store.getters['admin/Getexpense']
     })
   },
   getUserProfile(){
         this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_my_profile','variable':'users'}, { root: true }).then(() => {
        this.user=this.$store.getters['admin/Getusers']
      })
      },
   deleteexpense(id,index) {
     window.Swal.fire({
           title: 'are you sure',
           text: 'you want to delete this expense',
           icon: 'warning',
           showCancelButton: true,
           confirmButtonColor: '#3085d6',
           cancelButtonColor: '#d33',
           confirmButtonText: 'Yes'
         }).then((result) => {
           if (result.value) {
             this.$store.dispatch('admin/AdminController',{'data':{},'method':'delete','api':'admin_delete_transaction_admin','variable':'status','params':id}, { root: true }).then(() => {
        window.Toast.fire({
           icon: "success",
           title:'expense deleted successfuly',
         });
       this.expenses.data.splice(index,1)
     }).catch(()=>{
        window.Toast.fire({
           icon: "error",
           title:"expense can't be deleted !!",
         });
     })
           }
    });
   },
   update() {
    var form =window.VFToF(this.expense);
     console.log(form)

     this.$store
       .dispatch('admin/AdminController',{'data':form,'method':'post','api':'admin_update_rate','variable':'expense'}, { root: true })
       .then(() => {
         var data = this.$store.getters["admin/Getexpense"];
         this.expenses.data[this.updateindex].id=data.id
         this.expenses.data[this.updateindex].rate=data.rate
         this.expenses.data[this.updateindex].from=data.from
         this.expenses.data[this.updateindex].to=data.to
         this.expenses.data[this.updateindex].created_at=data.created_at
         this.display = false;
         this.$bvModal.hide("post-update-modal-expense");
          window.Toast.fire({
           icon: "success",
           title:'expense updated successfuly',
         });
       })
       .catch((err) => {
         this.expense.errors.errors = err;
       });
   },
   CreateData() {
    var holder=new window.Form({hours:this.hours,attachment:this.attachment})
    var form =window.VFToFD(holder);
    var api='admin_accept_transaction_admin'
    if(this.holder.state==2)
    api='admin_done_transaction_admin'
     this.$store.dispatch('admin/AdminController',{'data':form,'method':'post','api':api,'variable':'expense','params':this.holder.id}, { root: true }).then(() => {
         this.getmyexpense()
         this.display = false;
         this.hours=0
         this.attachment=''
         this.$bvModal.hide("post-update-modal-expense-view");
         if(this.holder.state==1){
         window.Toast.fire({
           icon: "success",
           title:'Transaction Accepted successfuly',
         });
        }else{
          window.Toast.fire({
           icon: "success",
           title:'Transaction Complited successfuly',
         });
        }
       })
       
   }
 },
};
</script>

<style scoped>
.search-controller{
 border-left:0;
 border-top-right-radius: 10px;
 border-bottom-right-radius: 10px;
}
::placeholder {
color: black;
 font-style: italic;
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
 font-size: 1em;
}
.grade-icon{
 color:#fbcf00;
 font-size: 1.5em;
}

.close{
   color:blacksmoke;
   opacity: 1;
}

.card {
 position: relative;
   display: flex;
   flex-direction: column;
   min-width: 0;
   word-wrap: break-word;
   background-color:white;
   background-clip: border-box;
   border: 0 solid #d9dee3;
   border-radius: 0.5rem;
}
.bg-gradient-danger{
 border-radius: 5px !important;
}
.bg-gradient-danger:hover{
 background:transparent !important;
 color:white;
}
.bg-gradient-danger:hover .top-1{
  position: relative;
 visibility:visible;
 top:0;
 width:100%;
 border:0;
 border-top:1.5px solid blue;
}
.bg-gradient-danger:hover .top-2{
position: relative;
 visibility:visible;
 bottom:0;
 float:right;
 width:100%;
 border-bottom:1.5px solid blue;  
}
.top-1{
 position: relative;
 visibility:hidden;
 top:0;
 width:20%;
 border:0;
 z-index: 0;
 border-top:1px solid blue;
 transition: all 0.700s;
 padding-bottom: 10px;
}
.top-2{
 position: relative;
 z-index: 0;
 visibility:hidden;
 bottom:0;
 float:right;
 width:20%;
 border:0;
 border-bottom:1px solid blue;
 transition: all 0.700s;
 padding-top:10px;
}


.panel{
    /*background: linear-gradient(to right, #570827,#2b0112);*/
   background: linear-gradient(to right, #0f2027, #203a43, #2c5364);

 padding: 0;
 border-radius: 10px;
 border: none;
 box-shadow: 0 0 0 5px rgba(0,0,0,0.05),0 0 0 10px rgba(0,0,0,0.05);
}
.panel .panel-heading{
 padding: 20px 15px;
 border-radius: 10px 10px 0 0;
 margin: 0;
}
.panel .panel-heading .title{
 color: #fff;
 font-size: 28px;
 font-weight: 500;
 text-transform: capitalize;
 line-height: 40px;
 margin: 0;
}
.panel .panel-heading .btn{
 color: rgba(255,255,255,0.5);
 background: transparent;
 font-size: 16px;
 text-transform: capitalize;
 border: 2px solid #fff;
 border-radius: 50px;
 transition: all 0.3s ease 0s;
}
.panel .panel-heading .btn:hover{
 color: #fff;
 text-shadow: 3px 3px rgba(255,255,255,0.2);
}
.panel .panel-heading .form-control{
 color: #fff;
 background-color: transparent;
 width: 35%;
 height: 40px;
 border: 2px solid #fff;
 border-radius: 20px;
 display: inline-block;
 transition: all 0.3s ease 0s;
}
.panel .panel-heading .form-control:focus{
 background-color: rgba(255,255,255,0.2);
 box-shadow: none;
 outline: none;
}
.panel .panel-heading .form-control::placeholder{
 color: rgba(255,255,255,0.5);
 font-size: 15px;
 font-weight: 500;
}
.panel .panel-body{ padding: 0; }
.panel .panel-body .table thead tr th{
 color: #fff;
 background-color: rgba(255, 255, 255, 0.2);
 font-size: 16px;
 font-weight: 500;
 text-transform: uppercase;
 padding: 12px;
 border: none;
}
.panel .panel-body .table tbody tr td{
 color: #fff;
 font-size: 15px;
 padding: 10px 12px;
 vertical-align: middle;
 border: none;
}
.panel .panel-body .table tbody tr:nth-child(even){ background-color: rgba(255,255,255,0.05); }
.panel .panel-body .table tbody .action-list{
 padding: 0;
 margin: 0;
 list-style: none;
}
.panel .panel-body .table tbody .action-list li{
 display: inline-block;
 margin: 0 5px;
}
.panel .panel-body .table tbody .action-list li a{
 color: #fff;
 font-size: 15px;
 position: relative;
 z-index: 1;
 transition: all 0.3s ease 0s;
}
.panel .panel-body .table tbody .action-list li a:hover{ text-shadow: 3px 3px 0 rgba(255,255,255,0.3); }
.panel .panel-body .table tbody .action-list li a:before,
.panel .panel-body .table tbody .action-list li a:after{
 content: attr(data-tip);
 color: #fff;
 background-color: #111;
 font-size: 12px;
 padding: 5px 7px;
 border-radius: 4px;
 text-transform: capitalize;
 display: none;
 transform: translateX(-50%);
 position: absolute;
 left: 50%;
 top: -32px;
 transition: all 0.3s ease 0s;
}
.panel .panel-body .table tbody .action-list li a:after{
 content: '';
 height: 15px;
 width: 15px;
 padding: 0;
 border-radius: 0;
 transform: translateX(-50%) rotate(45deg);
 top: -18px;
 z-index: -1;
}
.panel .panel-body .table tbody .action-list li a:hover:before,
.panel .panel-body .table tbody .action-list li a:hover:after{
 display: block;
}
.panel .panel-footer{
 color: #fff;
 background-color: transparent;
 padding: 15px;
 border: none;
}
.panel .panel-footer .col{ line-height: 35px; }
.pagination{ margin: 0; }
.pagination li a{
 color: #fff;
 background-color: transparent;
 border: 2px solid transparent;
 font-size: 18px;
 font-weight: 500;
 text-align: center;
 line-height: 31px;
 width: 35px;
 height: 35px;
 padding: 0;
 margin: 0 3px;
 border-radius: 50px;
 transition: all 0.3s ease 0s;
}
.pagination li a:hover{
 color: #fff;
 background-color: transparent;
 border-color: rgba(255,255,255,0.2);
}
.pagination li a:focus,
.pagination li.active a,
.pagination li.active a:hover{
 color: #fff;
 background-color: transparent;
 border-color: #fff;
}
.pagination li:first-child a,
.pagination li:last-child a{
 border-radius: 50%;
}
@media only screen and (max-width:767px){
 .panel .panel-heading .title{
     text-align: center;
     margin: 0 0 10px;
 }
 .panel .panel-heading .btn_group{ text-align: center; }
}
</style>